export default __webpack_public_path__ + "static/media/munnarr.0a4bb9e7.jpg";